import * as React from "react";
const SvgFile20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9.293 1.293A1 1 0 0 1 10 1h7v18H3V8a1 1 0 0 1 .293-.707l6-6ZM15 3h-4v6H5v8h10V3ZM6.414 7H9V4.414L6.414 7Z",
      clipRule: "evenodd"
    })
  );
export default SvgFile20Px;
